import {FilterConverter} from "../filter/FilterConverter";
import {FiltersStateInitializer} from "../defaultInitializer/FiltersStateInitializer";
import {getAPIGatewayDataFromParent, getExportResultsDataFromParent} from "../../handler/ParentDataHandler";
import {isINRegion, logOperationalMetric} from "../../util/CommonUtils";
import {convertToValidPackageState} from "../CommonUtils";

const metricProcessName = "SCC_PACKAGE_DOWNLOAD";
export async function getExportResults(filters, stationCode, view, leg) {

    var initializedFilters = FiltersStateInitializer(filters, [])
    var finalList=[];
    const startTime = Date.now();
    const NUMBER_OF_MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;

    for (let status of initializedFilters.packageStatuses) {
        var packageStatusMap = {}
        let from = 0;
        let modifiedRequest = await FilterConverter(initializedFilters, view, leg, packageStatusMap, status);
        let response = [];
        var lastUpdatedRange;
        if (initializedFilters.lastUpdatedStart !== "" || initializedFilters.lastUpdatedEnd !== "") {
            lastUpdatedRange = {
            "startTime" : initializedFilters.lastUpdatedStart ? new Date(initializedFilters.lastUpdatedStart).getTime() / 1000 : (new Date(initializedFilters.lastUpdatedEnd).getTime() - NUMBER_OF_MILLISECONDS_IN_DAY) / 1000 ,
            "endTime": initializedFilters.lastUpdatedEnd ? new Date(initializedFilters.lastUpdatedEnd).getTime() / 1000 : (new Date(initializedFilters.lastUpdatedStart).getTime() + NUMBER_OF_MILLISECONDS_IN_DAY) / 1000
            }
        }

        let request = {

            resourcePath: "/os/getDrillDownData",
            httpMethod: "post",
            processName: "oculus",
            requestBody: {
                "nodeId": stationCode,
                "packageStatusMap": packageStatusMap,
                "filters": modifiedRequest,
                "lastUpdatedRange": lastUpdatedRange,
                "size": 10000,
                "startingIndex": from
            }
        };
        try {
            if (isINRegion()) {
                response = await getExportResultsDataFromParent(request);
            } else {
                response = await getAPIGatewayDataFromParent(request);
            }
            if (response.status === 200) {
                logOperationalMetric(startTime, metricProcessName, "getDrillDownData", true);
                from += response.data.packageResultList.length;
                finalList.push.apply(finalList, convertToValidPackageState(response.data.packageResultList));
            } else {
                logOperationalMetric(startTime, metricProcessName, "getDrillDownData", false);
                return [];
            }
        } catch (error) {
            return []
        }
    }

    return  finalList;
    }


// WEBPACK FOOTER //
// ./src/commons/api/GetExportResults.js